// this is an autogenerated file from DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/SMSTemplateEditor/Content/SelectNumber/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_EditAutomation_EventActions_Content_EventAction_Content_Content_Content_SendCommunication_SMSTemplateEditor_Content_SelectNumber($parent_company_id: uuid!, $location_uuid: uuid!) {
  comms_mobile_numbers_outbound(
    where: {
      parent_company_id: { _eq: $parent_company_id }
      active: { _eq: true }
    }
    order_by: { number: asc }
  ) {
    id
    number
  }
  comms_defaults(
    where: { type: { _eq: "phone" }, location_id: { _eq: $location_uuid } }
    limit: 1
  ) {
    id
    sender_id
  }
}

`